import { ActionStructureAction } from '@/utils/types';

export const SET_VALUE = 'SET_VALUE';

export interface DataToSendStateType {
    [key: string]: {
        [key: string]: {
            required: boolean;
            toSend: any;
            valid: boolean;
        };
    };
}

export const dataToSendInitialState: DataToSendStateType = {};

export const dataToSendReducer = (state: DataToSendStateType, action: ActionStructureAction) => {
    switch (action.type) {
        case SET_VALUE:
            const { key, data, index } = action.payload;
            return {
                ...state,
                [key]: {
                    ...state[key],
                    [index]: data,
                },
            };
        default:
            throw new Error();
    }
};
